(function () {
  var sustentoThemeConfig = function ($mdThemingProvider, $rootScope) {
    $mdThemingProvider.definePalette('sustento-primary', {
      '50': 'e1f0f7',
      '100': 'b4daeb',
      '200': '82c1de',
      '300': '50a8d0',
      '400': '2b96c6',
      '500': '0583bc',
      '600': '047bb6',
      '700': '0470ad',
      '800': '0366a5',
      '900': '015397',
      'A100': 'c2e0ff',
      'A200': '8fc5ff',
      'A400': '5cabff',
      'A700': '429eff',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': [
        '400',
        '500',
        '600',
        '700',
        '800',
        '900'
      ]
    });

    $mdThemingProvider.definePalette('sustento-accent', {
      '50': 'e1f0f7',
      '100': 'b4daeb',
      '200': '82c1de',
      '300': '50a8d0',
      '400': '2b96c6',
      '500': '0583bc',
      '600': '047bb6',
      '700': '0470ad',
      '800': '0366a5',
      '900': '015397',
      'A100': 'c2e0ff',
      'A200': '8fc5ff',
      'A400': '5cabff',
      'A700': '429eff',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': [
        '400',
        '500',
        '600',
        '700',
        '800',
        '900'
      ]
    });

    $mdThemingProvider.definePalette('sustento-warn', {
      '50': 'fce7e6',
      '100': 'f8c2c1',
      '200': 'f39998',
      '300': 'ee706f',
      '400': 'eb5250',
      '500': 'e73331',
      '600': 'e42e2c',
      '700': 'e02725',
      '800': 'dd201f',
      '900': 'd71413',
      'A100': 'ffffff',
      'A200': 'ffd3d3',
      'A400': 'ffa0a0',
      'A700': 'ff8786',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': [
        '400',
        '500',
        '600',
        '700',
        '800',
        '900'
      ]
    });

    $mdThemingProvider.theme('sustento')
      .primaryPalette('sustento-primary')
      .accentPalette('sustento-accent', { 'default': '500' })
      .warnPalette('sustento-warn', { 'default': '500' });
  };

  sustentoThemeConfig.$inject = ['$mdThemingProvider'];
  angular.module('ecap').config(sustentoThemeConfig);

  var sustentoThemeRun = function ($rootScope) {
    if (!$rootScope.$themes) {
      $rootScope.$themes = {};
    }
    $rootScope.$themes['sustento'] = {
      primaryColor: '#0583bc',
      accentColor: '#e73331'
    };
  };

  sustentoThemeRun.$inject = ['$rootScope'];
  angular.module('ecap').run(sustentoThemeRun);
})();